import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/general/closeDia.svg'
import _imports_1 from '@/assets/general/securityLock.svg'


const _withScopeId = n => (_pushScopeId("data-v-55bb3efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "security" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "top" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "center"
}
const _hoisted_9 = { class: "popover" }
const _hoisted_10 = {
  key: 0,
  class: "input-box"
}
const _hoisted_11 = {
  key: 1,
  class: "showLoading"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logining" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "select-center"
}
const _hoisted_19 = { class: "info" }
const _hoisted_20 = { class: "bottom" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { icloudVerifi, getVerifi, getPhone } from "@/api/ios";
import { gaEvent } from "@/utils/format";
import { fa } from "element-plus/es/locale";
import { syncIOSPhotosApi } from "@/api/devices";
import { syncContactsListApi } from "@/api/chat/index";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'securityDialog',
  props: {
    // 是否为新增
    visible: {
        type: Boolean,
        default: true,
    },
    width: {
        type: String,
        default: 600,
    },
    appleID: {
        type: String,
    }
},
  emits: ["closeDialog"],
  setup(__props, { emit: __emit }) {

const props = __props

const vFocus = {
    mounted: (el: any) => {
        setTimeout(() => {
            el.focus()
        }, 200)
    }
}

const securityInput = ref(null)

const { t } = useI18n();
const store = useStore();
const emit = __emit;
let router = useRouter();
const visible = computed(() => props.visible);
const deviceInfo = computed(() => store.state.deviceInfo);
const restIos = computed(() => store.state.subscripts.effective_icloud_num);

const isShowPopover = ref(false)

onMounted(async () => {
    // 自动聚焦第一个输入框
    codeInputFocus(0)
    await getVerify()
    startTimer();

    let info = t("famikeep210['A message containing a verification code has been sent to xxx.']")
    console.log('info::', info);
})

const handleClose = () => {
    isShowPopover.value = false
    emit('closeDialog')
}

// 获取对应手机号码的验证码文案截取
const getVertical = () => {
    console.log("删除的item:", phoneNumber.value);
    let info = t("famikeep210['A message containing a verification code has been sent to xxx.']")
    console.log('info::', info);

    let temp = info.split('xxx')

    info = temp[0] + phoneNumber.value + temp[1]

    console.log("temp:", temp, info);
    return info
}

// 获取设备或者手机的验证码
const getVerify = async (id: any = props.appleID, isPhone: Boolean = false,) => {
    try {
        console.log('phoneNumber.value', id);
        let params: any = {
            to: isPhone ? 1 : 0,
            apple_id: props.appleID,
        }

        if (isPhone) {
            params.phone_id = id
        }

        const res = await getVerifi(params)
        console.log('res:', res);
        if (res.data.code == 200) {

        }

    } catch (err) {
        console.log('errr', err);
    }
}

const codeValue = ref('');
const inputFocus = ref(false);

const showLoading = ref(false)

// 当前选择发送验证码的是设备还是手机
const phoneReceive = ref(false)
const phoneNumber = ref('')

// 验证码类型
const verifyType = ref(0)
const incorrectVerify = ref([false, false, false, false, false, false])

// 验证码输入框input
const codeInputChange = async () => {
    if (codeValue.value && codeValue.value.length >= 6) {
        // do soming...
        showLoading.value = true
        console.log('codeValue.value', codeValue.value);
        let params = {
            apple_id: props.appleID,
            verify_type: verifyType.value,
            auth_code: codeValue.value
        }
        try {
            const res = await icloudVerifi(params)
            console.log('rrrrrrrrrrr', res);

            if (res.data.code == 200) {
                showLoading.value = false
                isShowPopover.value = false
                handleClose()
                router.push('home');
                let bindIos = 0
                store.state.deviceInfo.forEach((item: any) => {
                    if (item.apple_id) {
                        bindIos = bindIos + 1
                    }
                })
                gaEvent("Binddevice_iOS", {
                    event_category: "AddDevice",
                    event_label: `${bindIos}/${bindIos + restIos.value}`,
                });
                await store.dispatch("getUserInfo");
                await store.dispatch("getDeviceInfo")
                console.log('deviceList.value', deviceInfo.value, store.state.deviceInfo);
                for (const item of store.state.deviceInfo) {
                    console.log('1', item);
                    if (item.apple_id) {
                        console.log('item::::', item);
                        store.commit('setCurrentAppleId', item.apple_id)
                        store.commit(
                            "setCurrentDeviceId",
                            item.devices[0].id
                        );
                        store.commit(
                            "setCurrentDeviceInfo",
                            item.devices[0]
                        );
                        break;
                    }
                }
                let arr;
                let boundedDevice = ref();
                arr = store.state.deviceInfo.map((item: any) => {
                    // 有apple_id为苹果设备
                    if (!item.apple_id) {
                        if (item.model) {
                            return item.model;
                        } else {
                            return item.name;
                        }
                    } else {
                        return item.apple_id
                    }
                });
                boundedDevice.value = arr.join("、");
                store.commit("setBoundedDevice", boundedDevice.value);
                store.dispatch('updateMenuList')
                let params1 = {
                    apple_id: props.appleID,
                }
                syncContactsListApi(params1);
                syncIOSPhotosApi(params1)
            } else if (res.data.code == 400211) {
                showLoading.value = false
                console.log('here');
                isShowPopover.value = true
                console.log('isShowPopover', isShowPopover.value);
                incorrectVerify.value.forEach((item, index) => {
                    incorrectVerify.value[index] = true
                })
                codeValue.value = ""
                inputFocus.value = false
            } else if (res.data.code == 409002) {
                showLoading.value = false
                ElMessage({
                    message: t("famikeep210.The device has been bound to other account"),
                    type: "error",
                });
            } else if (res.data.code == 500) {
                showLoading.value = false
                console.log('500啦');
            }
        } catch (err: any) {
            showLoading.value = false
            isShowPopover.value = false
            if (err.response) {
                // 双重验证码错误
                if (err.response.data.code == 400211) {
                    console.log('here');
                    isShowPopover.value = true
                    incorrectVerify.value.forEach((item, index) => {
                        incorrectVerify.value[index] = true
                    })
                    codeValue.value = ""
                    inputFocus.value = false
                } else {
                    // 网络错误(清空输入框重新输入)
                    console.log('其他异常');
                    codeValue.value = ""
                    inputFocus.value = false
                }
            } else {
                // 网络错误(清空输入框重新输入)
                console.log('其他异常');
                codeValue.value = ""
                inputFocus.value = false
            }
        }
    }
};

// 验证码输入框失去焦点
const codeInputBlur = () => {
    inputFocus.value = false;
};

// 验证码输入框获取到焦点
const codeInputFocus = (index: any) => {
    inputFocus.value = true;
    // isShowPopover.value = false
    incorrectVerify.value[0] = false
};

watch(codeValue, (newV) => {
    // console.log('codeValue', newV, newV.length);
    incorrectVerify.value[newV.length] = false
    if (newV.length == 0) {
        inputFocus.value = true;
    }
    if (newV.length == 1) {
        isShowPopover.value = false
    }
})

const countDown = ref(60)
const showInResend = ref(true)
const timerId = ref(null);
// 启动定时器
const startTimer = () => {
    (timerId.value as any) = setInterval(() => {
        countDown.value = countDown.value - 1;

        // 在这里可以添加逻辑来检查是否应该停止定时器
        if (countDown.value <= 0) {
            stopTimer();
        }
    }, 1000);
};

// 停止定时器
const stopTimer = () => {
    clearInterval(timerId.value as any);
    timerId.value = null; // 清除定时器 ID
};

// 当前点击重发验证码，只针对于icloud，如果又针对手机又针对icloud，要问产品关于具体的需求处理以及等接口跑通之后才行
const resendVertical = async () => {
    if (!countDown.value) {
        await getVerify()
        verifyType.value = 0
        countDown.value = 60
        showInResend.value = true
        showSelect.value = false
        startTimer();

        phoneReceive.value = false
        verifyType.value = 0
    }
}

const phoneList = ref([])
const showSelect = ref(false)
const getPhoneList = async () => {
    // console.log('hhhhh', countDown.value, showInResend.value);
    if (countDown.value && !showInResend.value) return

    incorrectVerify.value.forEach((item, index) => {
        incorrectVerify.value[index] = false
    })
    try {
        if (!showSelect.value) {
            verifyType.value = 0
            phoneNumber.value = ''
            let params = {
                apple_id: props.appleID
            }
            const res = await getPhone(params)
            if (res.data.code == 200) {
                showInResend.value = false
                showInResend.value = false
                phoneList.value = res.data.data.phone_number_infos
                if (phoneList.value.length == 1) {
                    phoneReceive.value = true
                    getVerify((phoneList.value[0] as any).id, true)
                    verifyType.value = (phoneList.value[0] as any).id
                    phoneNumber.value = (phoneList.value[0] as any).obfuscated_number
                    stopTimer()
                    countDown.value = 60
                    startTimer();

                    // 自动聚焦第一个输入框
                    codeInputFocus(0)
                    // vFocus.mounted()
                    securityInput.value.focus()
                } else {
                    showSelect.value = true
                    stopTimer()
                    countDown.value = 0
                }
            }
        } else {
            if (verifyType.value) {
                getVerify(verifyType.value, true)
                showInResend.value = false
                countDown.value = 60
                startTimer();
                phoneReceive.value = true
                showSelect.value = false

                // 自动聚焦第一个输入框
                codeInputFocus(0)
            }
        }
    } catch (err) {
        console.log('errr:', err);

    }
}

const pickOption = (e: any) => {
    let tempItem: any = phoneList.value[e]
    phoneNumber.value = tempItem.obfuscated_number
    verifyType.value = tempItem.id
}


return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: props.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.visible) = $event)),
      width: __props.width,
      "show-close": false,
      "close-on-click-modal": "false"
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", {
          onClick: handleClose,
          class: "close"
        }, _hoisted_3)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("famikeep210.Two-Factor Authentication")), 1)
          ]),
          (!showSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    "popper-class": "dialogPopover",
                    width: 300,
                    visible: isShowPopover.value
                  }, {
                    reference: _withCtx(() => [
                      (!showLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 0 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[0] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[0]), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 1 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[1] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[1]), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 2 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[2] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[2]), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 3 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[3] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[3]), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 4 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[4] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[4]), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["code-item", [codeValue.value.length == 5 && inputFocus.value ? 'code-item-active' : '', incorrectVerify.value[5] ? 'code-item-error' : '']])
                            }, _toDisplayString(codeValue.value[5]), 3),
                            _withDirectives(_createElementVNode("input", {
                              class: "input-code",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeValue).value = $event)),
                              maxlength: 6,
                              type: "tel",
                              ref_key: "securityInput",
                              ref: securityInput,
                              onBlur: codeInputBlur,
                              onFocus: codeInputFocus,
                              onInput: codeInputChange
                            }, null, 544), [
                              [vFocus],
                              [_vModelText, codeValue.value]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep210['Incorrect verification code']")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (!phoneReceive.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("famikeep210.A message has been sent")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(getVertical()), 1))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_el_select, {
                  modelValue: phoneNumber.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
                  class: "select",
                  placeholder: _ctx.$t('famikeep210.Please select'),
                  onChange: pickOption
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.obfuscated_number,
                        value: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep210['Please select a phone number to receive the verification code.']")), 1)
                ])
              ])),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: _normalizeClass(["resend", countDown.value && showInResend.value ? 'clickResend' : 'obtain']),
              onClick: resendVertical
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("famikeep210.Resend Verification Code")) + " ", 1),
              (countDown.value && showInResend.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(countDown.value) + "s)", 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["obtain", [countDown.value && !showInResend.value ? 'clickResend' : '', !verifyType.value && showSelect.value ? 'clickResend' : '']]),
              onClick: getPhoneList
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("famikeep210.Get SMS Verification Code")), 1),
              (countDown.value && !showInResend.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(" + _toDisplayString(countDown.value) + "s)", 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}
}

})